import HotelDetailTabCard from "../../components/composite/hoteldetailcard/HotelDetailTabCard";
import HotelDetailCard from "../../components/composite/hoteldetailcard/HotelDetailCard";
import HotelHeaderCard from "../../components/composite/hotelListCard/hotellistHeader/HotelHeaderCard";
import Header from "../../sharedScreens/Header";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { HotelServices } from "../../services/hotelSearch/HotelSearchService";

const HotelListDetail = () => {
  const location = useLocation();
  const hotelId = location.state?.EMTCommonId;
  const [hotelData, setHotelData] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetchHotelDetails = async () => {
      if (!hotelId) return;
      setLoading(true);
      try {
        const response = await HotelServices.gethoteldetails({
          AgentCode: 1,
          EMTCommonID: "EMTHOTEL-4521578",
          UserName: "HotelAPIUserTest",
          Password: "hotelapitest6NKHbRNN4pSD9G2H",
        });
        setHotelData(response?.data);
      } catch (error) {
        console.error("Failed to fetch hotel details", error);
      } finally {
        setLoading(false);
      }
    };

    fetchHotelDetails();
  }, [hotelId]);

  return (
    <>
      <div className="grow">
        <div className="wrapper flex grow flex-col">
          <Header />
        </div>
        <HotelHeaderCard />
      </div>

      <main className="grow content" id="content" role="content">
        <div className="container-fluid">
          {loading ? (
            <p>Loading hotel details...</p>
          ) : hotelData ? (
            <>
              <h6>
                {hotelData.city}, {hotelData.countryCode},
                <strong> {hotelData.checkIn} </strong>,
                <strong> {hotelData.checkOut} </strong>, 1 Room, 1 Guest
              </h6>
              <div className="row">
                <HotelDetailCard hotel={hotelData} />
              </div>
              <div className="row">
                <HotelDetailTabCard hotel={hotelData} />
              </div>
            </>
          ) : (
            <p>No hotel details found.</p>
          )}
        </div>
      </main>
    </>
  );
};

export default HotelListDetail;
